if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.slides = [];
        this._listenersAttached = false;
        this._observer = null;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initSlides();
        this.attachListeners();
        this.scrollToOpenedMedia();
      }

      attachListeners() {
        if (this._listenersAttached) return;
        this._listenersAttached = true;

        const prevBtn = this.querySelector('.sophior-lightbox__prev');
        const nextBtn = this.querySelector('.sophior-lightbox__next');
        const counterEl = this.querySelector('.sophior-lightbox__counter');

        // Stop pointerup propagation — voorkomt dat ModalDialog sluit op button click
        [prevBtn, nextBtn, counterEl].forEach((btn) => {
          if (btn) btn.addEventListener('pointerup', (e) => e.stopPropagation());
        });

        if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.prevSlide(); });
        if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.nextSlide(); });

        // Keyboard navigatie
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); this.prevSlide(); }
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); this.nextSlide(); }
        });

        // Counter bijwerken op basis van welke slide in viewport is
        this.setupIntersectionObserver();
      }

      initSlides() {
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          this.slides = Array.from(content.querySelectorAll('[data-media-id]'));
        }
      }

      setupIntersectionObserver() {
        if (this._observer) this._observer.disconnect();
        const content = this.querySelector('.product-media-modal__content');
        if (!content || !this.slides.length) return;

        this._observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const index = this.slides.indexOf(entry.target);
                if (index !== -1) {
                  this.currentIndex = index;
                  this.updateCounter();
                  this.playActiveMedia(entry.target);
                }
              }
            });
          },
          { root: content, threshold: [0.5] }
        );

        this.slides.forEach((slide) => this._observer.observe(slide));
      }

      scrollToOpenedMedia() {
        if (!this.openedBy) return;
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        const target = this.slides.find((el) => el.getAttribute('data-media-id') === openedMediaId);
        if (!target) return;

        this.currentIndex = this.slides.indexOf(target);
        this.updateCounter();

        // Direct zonder smooth scroll bij open (jumpy anders)
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          const prev = content.style.scrollBehavior;
          content.style.scrollBehavior = 'auto';
          target.scrollIntoView({ inline: 'start', block: 'nearest' });
          // Herstel na frame
          requestAnimationFrame(() => { content.style.scrollBehavior = prev || ''; });
        }
      }

      updateCounter() {
        const counter = this.querySelector('.sophior-lightbox__counter');
        if (counter && this.slides.length) {
          counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
        }
      }

      playActiveMedia(slide) {
        const tpl = slide.querySelector('template');
        if (slide.nodeName === 'DEFERRED-MEDIA' && tpl && tpl.content.querySelector('.js-youtube')) {
          slide.loadContent();
        }
      }

      prevSlide() {
        const target = Math.max(0, this.currentIndex - 1);
        this.scrollToIndex(target);
      }

      nextSlide() {
        const target = Math.min(this.slides.length - 1, this.currentIndex + 1);
        this.scrollToIndex(target);
      }

      scrollToIndex(index) {
        const slide = this.slides[index];
        if (slide) slide.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
      }
    }
  );
}
